<template>
<div class="right-content">
    <template>
        <Card style="width:100%;">
            <RadioGroup v-model="welcomeType" size="large">
                <div class="radio-item">
                    <Radio label="text" size="large">
                        <Icon type="md-text" size="22" />
                        <span>文字</span>
                    </Radio>
                </div>
                <div class="radio-item">
                    <Radio label="image" size="large">
                        <Icon type="md-photos" size="22" />
                        <span>图片</span>
                    </Radio>
                </div>
                <div class="radio-item">
                    <Radio label="voice" size="large">
                        <Icon type="md-musical-note" size="22" />
                        <span>音频</span>
                    </Radio>
                </div>
                <!-- <div class="radio-item">
                    <Radio label="video" size="large">
                        <Icon type="ios-videocam" size="22" />
                        <span>视频</span>
                    </Radio>
                </div> -->
            </RadioGroup>
        </Card>
    </template>
    <!-- 文字方式 -->
    <Card v-show="welcomeType == 'text'" style="width:100%; margin-top:20px">
        <div style="text-align:center">
            <Input v-model="welcomeText" type="textarea" :rows="4" placeholder="请输入文字..." />
        </div>
    </Card>
    <!-- 图片方式 -->
    <Card v-show="welcomeType == 'image'" style="width:100%; margin-top:20px">
        <template>
            <template>
                <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="imageFile!=null">上传图片<input id="welcomeimg" class="file-input" type="file" accept="image/*" @change="addFile('image')" ref="inputer" :disabled="imageFile!=null"></Button><span style="color: red">（最多上传一张图片，图片大小限制为10m之内，支持bmp/png/jpeg/jpg/gif格式，建议尺寸360*200）</span>
                <div class="push-imgpreview">
                    <img src="" alt="" id="preview" v-show="imageFile">
                    <div v-show="imageFile"><Button type="error" @click="delPushImage">删除</Button></div>
                </div>
            </template>
        </template>
    </Card>

    <!-- 音频方式 -->
    <Card v-show="welcomeType == 'voice'" style="width:100%; margin-top:20px">
        <template>
            <div>
                <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="voiceFile!=null">上传音频<input id="welcomeVioce" class="file-input" type="file" accept=".mp3,.wma,.wav,.amr" @change="addFile('voice')" ref="inputer2" :disabled="voiceFile!=null"></Button><span style="color: red">（最多只能上传一段10mb之内的音频，播放长度不超过60s，mp3/wma/wav/amr格式）</span>
                <div class="push-imgpreview">
                    <audio v-show="voiceFile" src="" id="preview_voice" controls></audio>
                    <div v-show="voiceFile"><Button type="error" @click="delWelcomeVoice">删除</Button></div>
                </div>
            </div>

        </template>
    </Card>

    <!-- 视频方式 -->
    <Card v-show="welcomeType == 'video'" style="width:100%; margin-top:20px">
        <template>
            <div>
                <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="videoFile!=null">{{video_media_id?'更新视频':'上传视频'}}<input id="welcomeVideo" class="file-input" type="file" accept=".mp4" @change="addFile('video')" ref="inputer3" :disabled="videoFile!=null"></Button><span style="color: red">（最多只能上传一段10mb之内的视频，MP4格式）</span>
                <div class="push-imgpreview">
                    <video v-show="videoFile" src="" id="preview_video" controls></video>
                    <!-- <div v-show="videoFile"><Button type="error" @click="delWelcomeVideo">删除</Button></div> -->
                </div>
                <div v-show="videoCover">
                    <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="!videoCover">上传封面<input id="welcomeCover" class="file-input" type="file" accept=".jpg" @change="addFile('video_cover')" ref="inputer4" :disabled="!videoCover"></Button><span style="color: red">（最多只能上传一个视频封面，视频封面大小限制64KB之内，支持JPG格式）</span>
                    <div class="push-imgpreview">
                        <img src="" alt="" id="preview-video" v-show="videoCover">
                    </div>
                </div>
                <div v-show="videoCover"><Button type="error" @click="delWelcomeVideo">删除</Button></div>
                <div class="input-item"><span class="input-title">视频标题：</span><Input maxlength="10" prefix="ios-pricetags-outline" v-model="title" placeholder="请输入标题" style="width: 400px" clearable /><span style="color: red"> （标题最多10字）</span></div>
                <div class="input-item"><span class="input-title">视频简介：</span><Input maxlength="30" prefix="ios-create-outline" v-model="introduction" placeholder="请输入简介" style="width: 400px" clearable /><span style="color: red"> （简介最多30字）</span></div>
            </div>

        </template>
    </Card>

    <!-- 保存 -->
    <Card class="switch-btn" style="width:100%;">
        <div>
            <Button type="primary" @click="saveWelcomeSttings">保存</Button>
        </div>
    </Card>
    <!-- 加载 -->
    <Spin size="large" fix v-if="spinShow"></Spin>
</div>
</template>

<script>
import host from '../../js/host'
export default {
    data() {
        return {
            token: '',
            welcomeType: 'text',
            welcomeText: '', //欢迎词
            imageFile: null, //上传的图片
            shadeIndex: -1,
            voiceFile: null, //音频
            videoFile: null, //视频
            videoCover: false, //视频封面
            introduction: '', //视频描述
            title: '', //视频标题
            loadingStatus: false,
            spinShow: false,
            video_media_id: '', //视频id
            image_media_id: '',  //图片id
            voice_media_id: '', //音频id 
        }
    },
    methods: {
        //图片模式--上传图片回调
        upimgs(response) {
            // this.imgs.push(response.)
            if (response.code === 0) {
                this.formInline.images.push('' + response.data.url);
            }
        },
        delPushImage() {
            this.imageFile = null
            this.image_media_id = null
            let preview = document.querySelector('#preview')
            let inputDOM = this.$refs.inputer;
            inputDOM.value = "";
        },
        //删除上传的音频
        delWelcomeVoice() {
            this.voiceFile = null
            this.voice_media_id = null
            let preview = document.querySelector('#preview_voice')
            let inputDOM = this.$refs.inputer2;
            inputDOM.value = "";
        },
        //删除上传的视频
        delWelcomeVideo() {
            this.videoFile = null
            this.videoCover = null
            this.voice_media_id = null
            let preview = document.querySelector('#preview_video')
            let inputDOM = this.$refs.inputer3;
            inputDOM.value = "";
            let preview2 = document.querySelector('#preview-video')
            let inputDOM2 = this.$refs.inputer4;
            inputDOM2.value = "";
            preview2.src = ''
        },
       //获取文件尺寸
        GetfileSize(elementID) {
            let file = document.getElementById(elementID)
            let size = 0
            if (file.value) {
                if (file.files) {
                    size = file.files[0].size
                }
                else {
                    let imgid = "img" + elementID
                    let obj_img = document.getElementById(imgid)
                    obj_img.dynsrc = file.value
                    size = obj_img.fileSize
                }
            }
            return (size/(1024*1024)).toFixed(3)
        },
        addFile(type) { 
            let that = this;
            if (type == 'image') {
                let welcomeimgSize = this.GetfileSize('welcomeimg')
                console.log(welcomeimgSize)
                if(welcomeimgSize < 10) {
                    this.image_media_id = ''
                    let inputDOM = that.$refs.inputer;
                    let file = inputDOM.files[0];
                    let form = new FormData();
                    form.append('file', file);
                    form.append('welcomeType', 'image');
                    console.log(form)
                    this.imageFile = form
                    //文件预览
                    let preview = document.querySelector('#preview')
                    let imgUrl = window.URL.createObjectURL(file)
                    preview.setAttribute("src", imgUrl)
                    // 更改img url 以后释放 url
                    preview.onload = function () {
                        // console.log('图片加载成功')
                        URL.revokeObjectURL(imgUrl)
                    }
                }else {
                    this.$Message.error('文件尺寸过大')
                }
               
            } else if (type == 'voice') {
                let welcomeVioceSize = this.GetfileSize('welcomeVioce')
                if(welcomeVioceSize < 10) {
                     this.voice_media_id = ""
                    let fileDOM = that.$refs.inputer2
                    let file = fileDOM.files[0];
                    console.log(file)
                    let form = new FormData();
                    form.append('file', file);
                    form.append('welcomeType', 'voice');
                    this.voiceFile = form
                    //文件预览
                    let preview_voice = document.querySelector('#preview_voice')
                    let imgUrl = window.URL.createObjectURL(file)
                    console.log(imgUrl)
                    preview_voice.setAttribute("src", imgUrl)
                    // 更改img url 以后释放 url
                    preview_voice.onload = function () {
                        URL.revokeObjectURL(imgUrl)
                    }
                }else {
                    
                }
               
            } else if (type == 'video') {
                let welcomeVideoSize = this.GetfileSize('welcomeVideo')
                console.log(welcomeVideoSize)
                if(welcomeVideoSize < 10) {
                     this.video_media_id = ''
                    let title = this.title
                    let introduction = this.introduction
                    let fileDOM = that.$refs.inputer3
                    let file = fileDOM.files[0];
                    console.log(file)
                    let form = new FormData();
                    form.append('file', file);
                    form.append('welcomeType', 'video');

                    this.videoFile = form
                    //文件预览
                    let preview_video = document.querySelector('#preview_video')
                    let imgUrl = window.URL.createObjectURL(file)
                    console.log(imgUrl)
                    preview_video.setAttribute("src", imgUrl)
                    // 更改img url 以后释放 url
                    preview_video.onload = function () {
                        URL.revokeObjectURL(imgUrl)
                    }
                    this.videoCover = true
                }else {
                   
                }
               
            } else if (type == 'video_cover') {
                let welcomeCoverSize = this.GetfileSize('welcomeCover')
                if(welcomeCoverSize < 0.64) {
                      this.video_media_id = ''
                    let videoFile = this.videoFile
                    let fileDOM = that.$refs.inputer4
                    let file = fileDOM.files[0];
                    videoFile.append('thumb', file)
                    this.videoFile = videoFile
                    this.videoCover = true
                    //文件预览
                    let preview_video = document.querySelector('#preview-video')
                    let imgUrl = window.URL.createObjectURL(file)
                    console.log(imgUrl)
                    preview_video.setAttribute("src", imgUrl)
                    // 更改img url 以后释放 url
                    preview_video.onload = function () {
                        URL.revokeObjectURL(imgUrl)
                    }
                }else {
                     this.$Message.error('封面尺寸过大')
                    return false
                }
            }
        },
        saveWelcomeSttings() {
            let modal_content = ''
            let welcomeType = this.welcomeType
            let content = this.welcomeText
            let title = this.title
            let introduction = this.introduction
            if (welcomeType == 'voice') {
                if (this.voiceFile) {
                    let voiceSize = this.GetfileSize('welcomeVioce')
                    console.log(voiceSize)
                    modal_content = '<div>设置欢迎词为音频模式</div>'
                    // if(voiceSize <= 2) {
                        this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (welcomeType == 'voice') {
                                console.log(this.token)
                                this.$axios.post('/weixin/admin/welcomeUpdate', this.voiceFile, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        //   this.currrntPushImage = res.data.data.push_image_url
                                        // this.formInline.images[0] = res.data.data.push_image_url
                                        this.$Message.success('设置成功')
                                        this.getInfo()
                                    } else {
                                        this.$Message.error('请重新上传音频')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                        });
                    // }else {
                    //     this.$Message.error('音频文件过大')
                    // }
                } else {
                    this.$Message.error('请上传音频文件')
                }
            } else if (welcomeType == 'text') {
                if (content) {
                    modal_content = '<div>设置欢迎词为文字</div>'
                    this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (welcomeType == 'text') {
                                this.$axios.post('/weixin/admin/welcomeUpdate', {
                                    welcomeType: welcomeType,
                                    content: content,
                                }, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        this.$Message.success('设置成功')
                                        this.getInfo()
                                    } else {
                                        this.$Message.error('设置失败')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                    });
                } else {
                    this.$Message.warning('请输入文字')
                }
            } else if (welcomeType == 'image') {
                if (this.imageFile != null) {
                    modal_content = '<div>设置欢迎词为图片模式</div>'
                    let welcomeImgSize = this.GetfileSize('welcomeimg')
                    console.log(welcomeImgSize)
                    if(welcomeImgSize < 2) {
                        this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (welcomeType == 'image') {
                                console.log(this.token)
                                this.$axios.post('/weixin/admin/welcomeUpdate', this.imageFile, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        //   this.currrntPushImage = res.data.data.push_image_url
                                        // this.formInline.images[0] = res.data.data.push_image_url
                                        this.$Message.success('设置成功')
                                        this.getInfo()
                                    } else {
                                        this.$Message.error('请重新上传图片')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                        });
                    }else {
                        this.$Message.warning('图片文件过大')
                    }
                } else {
                    this.$Message.warning('请上传图片')
                }
            } else if (welcomeType == 'video') {
                if (this.videoFile) {
                    modal_content = '<div>设置欢迎词为视频模式</div>'
                    this.videoFile.append('title', title);
                    this.videoFile.append('introduction', introduction);
                    this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (welcomeType == 'video') {
                                console.log(this.token)
                                this.$axios.post('/weixin/admin/welcomeUpdate', this.videoFile, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        //   this.currrntPushImage = res.data.data.push_image_url
                                        // this.formInline.images[0] = res.data.data.push_image_url
                                        this.$Message.success('设置成功')
                                        this.getInfo()
                                    } else {
                                        this.$Message.error('设置失败')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                    });
                } else {
                    this.$Message.warning('请上传视频文件')
                }
            }
        },

        //获取当前已设置的欢迎词
        getInfo() {
            this.spinShow = true
            this.$axios.post('/weixin/admin/getInfo', {}, {
                headers: {
                    Authorization: this.token
                }
            }).then(res => {
                this.spinShow = false
                if(res.data.code == 0) {
                    let info = res.data.data.data
                    this.welcomeType = info.welcome_type
                    this.welcomeText = info.content
                    this.title = info.video_title
                    this.introduction = info.video_introduction
                    this.image_media_id = info.image_media_id
                    this.video_media_id = info.video_media_id
                    this.voice_media_id = info.voice_media_id
                    if(this.welcomeType == 'image') {
                        this.imageFile = true
                        this.welcomeText =''
                        setTimeout( ()=> {
                            let preview = document.querySelector('#preview')
                            let imgUrl = `${host}/${info.image_local_url}`
                            preview.setAttribute("src", imgUrl)
                        })
                    }else if(this.welcomeType == 'voice') {
                        this.voiceFile = true
                         this.welcomeText =''
                        setTimeout(()=> {
                            let preview = document.querySelector('#preview_voice')
                            let voice_url = `${host}/${info.voice_local_url}`
                            preview.setAttribute("src", voice_url)
                        })
                    }
                }else {
                    this.$Message.error('数据获取失败')
                }
               
            })
        }
    },
    created() {
        this.token = localStorage.getItem('token')
        this.getInfo()
    },
    mounted() {
        // this.videoFile = new FormData()
    }
}
</script>

<style>
.push-img-btn {
    position: relative;
    width: 120px;
    overflow: hidden;
}

.push-imgpreview {
    margin: 15px 20px;
}

#preview-video {
    max-height: 300px;
}

.push-imgpreview video {
    max-width: 300px
}
</style>
